import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp, FiHelpCircle } from 'react-icons/fi';
import './FAQ.css';

const FAQ = () => {
  // FAQ data
  const faqItems = [
    {
      id: 1,
      question: 'Do you take insurance?',
      answer: 'Prime Pharmacenter delivers to most locations across the United States. Delivery times typically range from 3-5 days. Depending on your location for eligible prescriptions, we offer expedited shipping to ensure you never run low on your medications.'
    },
    {
      id: 2,
      question: 'Can I transfer my prescription to PrimeCare Pharmacenter?',
      answer: 'Yes, you can easily transfer your prescription to PrimeCare Pharmacenter. Simply provide us with your prescription information, including the Rx number, pharmacy name, and pharmacy phone number, and our team will handle the transfer process for you.'
    },
    {
      id: 3,
      question: 'Does PrimeCare Pharmacenter offer worldwide delivery service?',
      answer: 'Currently, PrimeCare Pharmacenter primarily serves customers within the United States. If you have international shipping needs, please contact our customer service team to discuss available options for your specific location.'
    },
    {
      id: 4,
      question: 'Can PrimeCare Pharmacenter help me with medication management?',
      answer: 'Yes, PrimeCare Pharmacenter offers comprehensive medication management services. Our licensed pharmacists can review your medications, provide counseling on proper usage, and help you develop a schedule to ensure you re taking your medications correctly and on time.'
    },
    {
      id: 5,
      question: 'What payment options does PrimeCare Pharmacenter accept?',
      answer: 'PrimeCare Pharmacenter accepts various payment methods including all major credit cards (Visa, MasterCard, American Express, Discover), PayPal, and bank transfers. We do not currently accept insurance payments directly, but we can provide receipts for you to submit to your insurance provider for possible reimbursement.'
    },
    {
      id: 6,
      question: 'Does PrimeCare Pharmacenter carry over-the-counter products?',
      answer: 'Yes, PrimeCare Pharmacenter carries a wide range of over-the-counter medications, supplements, and health products in addition to prescription medications. You can browse our full selection in our online store.'
    }
  ];

  // State to track which items are expanded
  const [expandedItems, setExpandedItems] = useState({});

  // Toggle FAQ item
  const toggleItem = (id) => {
    setExpandedItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  return (
    <section className="faq-section">
      <div className="conta">
        <div className="faq-header">
          <FiHelpCircle className="faq-header-icon" />
          <h2 className="faq-title">Frequently Asked Questions</h2>
          <p className="faq-subtitle">Find answers to common questions about our services</p>
        </div>

        <div className="faq-list">
          {faqItems.map(item => (
            <div
              key={item.id}
              className={`faq-item ${expandedItems[item.id] ? 'active' : ''}`}
            >
              <div
                className="faq-question"
                onClick={() => toggleItem(item.id)}
              >
                <div className="question-content">
                  <span className="question-number">0{item.id}</span>
                  <span className="question-text">{item.question}</span>
                </div>
                <span className="toggle-icon">
                  {expandedItems[item.id] ? <FiChevronUp /> : <FiChevronDown />}
                </span>
              </div>

              <div className={`faq-answer ${expandedItems[item.id] ? 'open' : ''}`}>
                <div className="answer-content">
                  <p>{item.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;